import styled from 'styled-components';
import {
  Form,
} from 'antd';
import {
  Button,
} from 'UI';

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0.375rem;
  padding-top: 0.5rem;
`;

export const NameInputFormItem = styled(Form.Item)`
  flex-grow: 1;
  padding-right: 0.375rem;
  margin-bottom: 0;
`;

export const AddButton = styled(Button)`
  width: auto;
  flex-grow: 1;
`;
